import React from 'react'
import {useIntl} from 'react-intl'
import {facilityCategoryTitleMessages} from 'utils/facilities'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'

import {CategoryIcon} from './CategoryIcon'
interface Props {
  categoryId: string
  facilities: string[]
}
export const FacilitiesGroupItem: React.FC<Props> = ({
  categoryId,
  facilities
}) => {
  const {formatMessage} = useIntl()

  const translatedCategoryTitle = facilityCategoryTitleMessages[categoryId]

  return (
    <Box display="flex" flexDirection="column" gap="s500">
      <Box display="flex" alignItems="center" gap="s300">
        <CategoryIcon categoryId={categoryId} />
        <Text variant="titleL" tag="p">
          {formatMessage(translatedCategoryTitle)}
        </Text>
      </Box>

      {facilities.map(facility => (
        <Text key={facility}>{facility}</Text>
      ))}
    </Box>
  )
}
